import {
  AgStepbarItem,
  AgDropMenu,
  AgDropMenuContent
} from '@rededor/ag-shared-components-react'
import { useStepStatus } from '@/hooks/useStepStatus'
import { useScheduleStore } from '@/store/useScheduleStore'
import { useStepAction } from './useStepAction'

export const PaymentStep = () => {
  const healthPlanStore = useScheduleStore((state) => state.healthPlan)
  const healthCarrierStore = useScheduleStore((state) => state.healthCarrier)
  const targetStep = 'payment'

  const status = useStepStatus({
    isCompleted: Boolean(healthPlanStore?.id),
    targetPath: '/pagamento',
    targetStep
  })

  const { handleClickAction, handleSelectStep } = useStepAction('/pagamento')

  const info = healthCarrierStore?.id
    ? `${healthCarrierStore?.name} - ${healthPlanStore?.name}`
    : undefined

  return (
    <AgStepbarItem
      step="Pagamento"
      info={info}
      onSelectStep={handleSelectStep}
      icon="healthPlan"
      status={status}
      targetStep={targetStep}
    >
      <AgDropMenu>
        <AgDropMenuContent
          step="Pagamento"
          info={info}
          labelAction="Alterar forma de pagamento"
          onClickAction={handleClickAction}
        />
      </AgDropMenu>
    </AgStepbarItem>
  )
}
